import { FaRegArrowAltCircleRight } from 'react-icons/fa'
import { Button } from '../../../../../../components/Button'
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Grid,
  Icon,
  Image,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from '@chakra-ui/react'
import React from 'react'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import { ListItem } from './ListItem'
import { api } from '../../../../../../services/api'
import { useQuery } from 'react-query'

async function getInfoListLayout({ numeroPedido, codigo_produto, sequencia }) {
  const response = await api.get(`/site/v2/orcamento-crm/listar-layouts_pedido/${numeroPedido}/${codigo_produto}/${sequencia}`)

  return response.data
}

export function ModalHistoricoLayout({ item, num_proposta }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()

  const { data: listaLayout = [] } = useQuery({
    queryKey: ['infoListLayout', num_proposta],
    queryFn: () =>
      getInfoListLayout({
        numeroPedido: num_proposta,
        codigo_produto: item.codigo_produto,
        sequencia: item.sequencia,
      }),
    enabled: !!isOpen,
    refetchOnWindowFocus: false,
  })

  return (
    <>
      <Button
        bgColor="transparent"
        fontSize="13px"
        size="sm"
        color="#2D2D2D"
        onClick={onOpen}
        _hover={{ filter: 'brightness(0.9)', bgColor: '#d3d3d3' }}
        rightIcon={<Icon as={FaRegArrowAltCircleRight} color="#378BBF" fontSize="19px" />}
        pointerEvents="auto"
      >
        Histórico
        <Text as="span" color="#378BBF" fontWeight="semibold" ml={1}>
          Layout
        </Text>
      </Button>

      <Drawer isOpen={isOpen} onClose={onClose} finalFocusRef={btnRef} placement="bottom">
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <DrawerHeader bgColor="#378BBF" textAlign="center" color="#F5F5F5" textTransform="uppercase">
            Histórico de Layout
          </DrawerHeader>

          <DrawerBody w="100%" mx="auto" display="flex" flexDir="column" alignItems="center" gap={4}>
            <Box p={0} border="1px solid #CFCFCF">
              <Flex flexDir="column" w="full" alignItems="flex-start">
                <Flex alignItems="center" w="full" justifyContent="space-between" borderBottom="1px solid #CFCFCF">
                  <Flex alignItems="center" px="23px" py="9px" fontWeight="semibold" fontSize="15px">
                    <Text as="span" color="#378BBF">
                      Item 1
                    </Text>
                    <Text color="#2D2D2D" as="span">
                      | {item.nome_produto} | {item.codigo_produto}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
              <Grid
                px="23px"
                py="20px"
                fontSize="13px"
                alignItems="center"
                justifyContent="space-between"
                width="full"
                gridTemplateColumns="200px 302px 196px 275px 1fr"
              >
                <Flex gap={'14px'} alignItems="center" borderRight="1px solid #CFCFCF">
                  <Flex alignItems="center" justifyContent="center" w="55px" h="76px" border="1px solid #CFCFCF" borderRadius="10px">
                    <Image src={item.imagens_produto[0].url} objectFit="contain" alt="item" boxSize="63px" />
                  </Flex>

                  <Flex flexDir="column" alignSelf="flex-start" py="9px">
                    <Text isTruncated maxW="120px">
                      <strong>Cor:</strong> {item.descricao_cor}
                    </Text>
                    <Text>
                      <strong>Impressão:</strong> 1
                    </Text>
                  </Flex>
                </Flex>

                <Flex borderRight="1px solid #CFCFCF" px={'27px'} py="9px" alignItems="start" h="100%" flexDir="column">
                  <Text>
                    <b>Personalização:</b> {item.nome_personalizacao}
                  </Text>
                  <Text>
                    <b>Prazo:</b> {item.prazo} dias úteis
                  </Text>
                  <Text>
                    <b>Quantidade:</b> {item.quantidade}
                  </Text>
                </Flex>

                <Flex borderRight="1px solid #CFCFCF" px={'27px'} py="9px" alignItems="start" h="100%" flexDir="column">
                  <Text>
                    <b>Preço base:</b> {item.preco_base}
                  </Text>
                  <Text>
                    <b>Preço site:</b> {item.preco_site}
                  </Text>
                </Flex>
                <Flex borderRight="1px solid #CFCFCF" px={'27px'} py="9px" alignItems="start" h="100%" flexDir="column">
                  <Text>
                    <b>Substituição tributária:</b> {item.vlr_substituicao}
                  </Text>
                  <Text>
                    <b>Preço venda:</b> {item.preco_venda}
                  </Text>
                </Flex>
                <Flex px={'27px'} py="9px" alignItems="start" h="100%" flexDir="column">
                  <Text>
                    <b>Valor total dos itens:</b> {item.valor_total_itens}
                  </Text>
                  <Text>
                    <b>Preço do frete:</b> R$ 0
                  </Text>
                  <Text>
                    <b>Valor total:</b> {item.valor_total_itens}
                  </Text>
                </Flex>
              </Grid>
            </Box>

            <TableContainer border="1px solid #cfcfcf">
              <Table variant="unstyled" borderCollapse="collapse">
                <Thead>
                  <Tr borderBottom="1px solid #cfcfcf">
                    <Th
                      borderRight="1px solid #cfcfcf"
                      textAlign="center"
                      fontWeight="normal"
                      color="#378BBF"
                      textTransform="capitalize"
                      fontSize="15px"
                      letterSpacing="9"
                      py={2}
                    >
                      Link Logo
                    </Th>
                    <Th
                      borderRight="1px solid #cfcfcf"
                      textAlign="center"
                      fontWeight="normal"
                      color="#378BBF"
                      textTransform="capitalize"
                      fontSize="15px"
                      letterSpacing="9"
                      py={2}
                    >
                      Link Layout
                    </Th>
                    <Th
                      borderRight="1px solid #cfcfcf"
                      textAlign="center"
                      fontWeight="normal"
                      color="#378BBF"
                      textTransform="capitalize"
                      fontSize="15px"
                      letterSpacing="9"
                      py={2}
                    >
                      Arte Finalista
                    </Th>
                    <Th
                      borderRight="1px solid #cfcfcf"
                      textAlign="center"
                      fontWeight="normal"
                      color="#378BBF"
                      textTransform="capitalize"
                      fontSize="15px"
                      letterSpacing="9"
                      py={2}
                    >
                      Solicitado
                    </Th>
                    <Th
                      borderRight="1px solid #cfcfcf"
                      textAlign="center"
                      fontWeight="normal"
                      color="#378BBF"
                      textTransform="normal"
                      fontSize="15px"
                      letterSpacing="9"
                      py={2}
                    >
                      Encaminhado ao Cliente
                    </Th>
                    <Th textAlign="center" fontWeight="normal" color="#378BBF" textTransform="capitalize" fontSize="15px" letterSpacing="9" py={2}>
                      Aprovado
                    </Th>
                    <Th />
                  </Tr>
                </Thead>

                <Tbody>
                  <ListItem list={listaLayout} codigo_produto={item.codigo_produto} sequencia={item.sequencia} />
                </Tbody>
              </Table>
            </TableContainer>
          </DrawerBody>

          <DrawerFooter position="sticky" mt="auto" bottom="0" boxShadow="0px 3px 6px rgba(0, 0, 0, 0.635)">
            <Flex alignItems="center" justifyContent="center" w="100%" gap={2}>
              <Button
                maxW="181px"
                w="100%"
                fontSize="15px"
                fontWeight="semibold"
                bgColor="transparent"
                color="#FFA200"
                border="1px solid #FFA200"
                onClick={onClose}
              >
                <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                Voltar
              </Button>

              <Button maxW="181px" w="100%" fontSize="15px" fontWeight="semibold" _hover={{ filter: 'brightness(0.9)' }} onClick={onClose}>
                Salvar alterações
              </Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}
